/* Replace the old contact address with box@chowa.nyc everywhere it
   still appears in content we cannot edit directly (Shopify policy
   pages, app-rendered text). Runs on load and after the app renders. */
(function () {
  var OLD = 'hello@intowhat.com';
  var NEW = 'box@chowa.nyc';
  var OLD_RE = /hello@intowhat\.com/gi;

  function fixLinks(root) {
    var links = root.querySelectorAll('a[href*="intowhat"]');
    for (var i = 0; i < links.length; i++) {
      var href = links[i].getAttribute('href') || '';
      if (href.toLowerCase().indexOf(OLD) !== -1) {
        links[i].setAttribute('href', href.replace(OLD_RE, NEW));
      }
    }
  }

  function fixText(root) {
    var walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, null, false);
    var node;
    var hits = [];
    while ((node = walker.nextNode())) {
      if (node.nodeValue && OLD_RE.test(node.nodeValue)) {
        OLD_RE.lastIndex = 0;
        hits.push(node);
      }
      OLD_RE.lastIndex = 0;
    }
    for (var i = 0; i < hits.length; i++) {
      hits[i].nodeValue = hits[i].nodeValue.replace(OLD_RE, NEW);
    }
  }

  function run() {
    if (!document.body) return;
    fixLinks(document.body);
    fixText(document.body);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }
  var ticks = 0;
  var timer = setInterval(function () {
    ticks++;
    run();
    if (ticks > 12) clearInterval(timer);
  }, 400);
})();
